module.exports = __webpack_public_path__ + "img/calendar-week.52d34bb6.svg";